import * as React from "react"
import {useEffect, useMemo} from "react"
import {CardSeeker} from "@ui-seeker/core";
import {Grid} from "@mui/material";

import {MatchersLoadingSkuBlock} from "../../@components";
import {useRawMatcherBrandSkus} from "../@hooks";
import SkuOption from "./ProductOption";
import RawMatcherOptionsFilters from "./Filters";
import RawMatcherImageComparisonModal from "./ImageComparisonModal";


export default function RawMatcherOptions({ showOptions, showMappedSkus=true, targetIndex, productID, productName, productThumbnail, brandID, siteID, retailer, country, options=[], selected=null, setSelectedSKU, saveMapping }) {
	const { brandOptions, isLoading, searchText, handleChangeSearchText } = useRawMatcherBrandSkus(brandID, siteID, options.map(({skuID}) => skuID))

	useEffect(() => {
		handleChangeSearchText('')
	}, [targetIndex]);

	// The array the comparison modal pages through, and each sku's position in it. Computed
	// once per list instead of a findIndex over a fresh spread for every card on every render.
	const modalOptions = useMemo(
		() => showOptions && !searchText ? [...options, ...(brandOptions ?? [])] : (brandOptions ?? []),
		[showOptions, searchText, options, brandOptions]
	)
	const modalIndexBySku = useMemo(() => {
		const index = new Map()
		modalOptions.forEach((item, idx) => { if (!index.has(item.skuID)) index.set(item.skuID, idx) })
		return index
	}, [modalOptions])
	const aiSkuIDs = useMemo(() => new Set(options.map(op => op.skuID)), [options])

	return <CardSeeker>
		<Grid container spacing={2}>
			<Grid item xs={12}>
				<RawMatcherOptionsFilters
					searchText={searchText}
					onInputChange={handleChangeSearchText}
				/>
			</Grid>

			{ !!isLoading && <Grid item xs={12}>
				<MatchersLoadingSkuBlock />
			</Grid> }

			<Grid item xs={12}>
				<Grid container spacing={2} maxHeight="70vh" sx={{ overflowY: "auto" }}>
					{ !isLoading && !searchText && options.filter(op => showOptions || op.skuID === selected).map((data, idx) => <SkuOption key={data.skuID}
							isIAOption
							productID={productID}
							productName={productName}
							siteID={siteID}
							productThumbnail={productThumbnail}
							skuID={data.skuID}
							isSelected={selected !== null && selected === data.skuID}
							data={data}
							setSelectedSKU={setSelectedSKU}
							brandOptionsIndex={idx}
						/>) }

					{ !isLoading && brandOptions
						.filter(data => showMappedSkus || !data.alreadyMapped)
						.map((data, idx) => {
							const modalIndex = modalIndexBySku.get(data.skuID)

							return <SkuOption key={data.skuID}
									isIAOption={aiSkuIDs.has(data.skuID)}
									productID={productID}
									productName={productName}
									siteID={siteID}
									productThumbnail={productThumbnail}
									skuID={data.skuID}
									isSelected={selected !== null && selected === data.skuID}
									data={data}
									setSelectedSKU={setSelectedSKU}
									brandOptionsIndex={modalIndex !== undefined ? modalIndex : idx}
								/>
						}) }
				</Grid>
			</Grid>
		</Grid>

		<RawMatcherImageComparisonModal
			brandOptions={modalOptions}
			setSelectedSKU={setSelectedSKU}
			saveMapping={saveMapping}
		/>
	</CardSeeker>
}
